import styled, { css } from 'styled-components';
import { colors } from '@karnott/colors';
import { DeleteIcon } from '@karnott/icons';

type Props = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  'data-testid'?: string;
};

/** A small round black button with a cross, to reset a form popup's value */
export function ResetButton({ label, onClick, disabled = false, 'data-testid': testId }: Props) {
  return (
    <Button type="button" aria-label={label} onClick={onClick} disabled={disabled} data-testid={testId}>
      <DeleteIcon circled size={15} color={colors('white')} backgroundColor={colors('black')} />
    </Button>
  );
}

const Button = styled.button`
  all: unset;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.8;
        `
      : css`
          &:hover > div {
            background-color: ${colors('red')};
          }
        `}
`;
